<template>
  <div>
    <CRUDDialog
    v-if="paymentReRenderFlag"
    ref="crudDialog"
    :baseCrudKey='baseCrudKey'
    :canSave="false"
    @crudDialogEnter="guardedPreUpsert"
      ><template v-slot:[`editedItem`]="{}">
        <paymentDialog :baseCrudKey="baseCrudKey" :isItFromJuneResale="isItFromJuneResale"
        :selectedComponentCriteria="selectedComponentCriteria" />
        </template>
        <template v-slot:[`additionalActionsAfterSave`]="{}">
          <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || 'n/a'"
                :itemIsSaved="!isNewItem"
                ref="uploadFile"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    :disabled="enableUploadFile"
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(false)" :disabled="isSaveBlocked">Save</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(true)" :disabled="isSaveBlocked">Save & print</v-btn>
        </template>
      </CRUDDialog>
      <CommonPopUp v-model="popUpMtgCodeRemoveOrNot" v-if="popUpMtgCodeRemoveOrNot"
      :enableFlashTypeMsg="false">
        <template v-slot:customsLabelOrInfo>
          <span class="elevation-1"><br/>
          <p style="white-space: pre;">
            <v-icon class="ChangeIconRedColor">
              {{ icons.mdiCircleSlice8 }}
            </v-icon> {{ getMtgCodesMsg() }}
          </p>
        </span>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openPopUpForMtgCodeRemoveOrNot('Remove')">Remove</v-btn>
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openPopUpForMtgCodeRemoveOrNot('Close')">Close</v-btn>
        </template>
    </CommonPopUp>
    <CommonPopUp v-model="showOrHideLatestPostDate" v-if="showOrHideLatestPostDate"
        :enableFlashTypeMsg="true" flashType="warning">
        <template v-slot:customsLabelOrInfo>
          <p class="mt-3">Payments have been posted through {{ paymentSettingItem.latestPostDate }}.
            Are you sure you wish to create a payment transaction on {{ editedItem.payDate }}
          </p>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="openConfirmPopUp('Continue')">Continue</v-btn>
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="openConfirmPopUp('Cancel')">Cancel</v-btn>
        </template>
      </CommonPopUp>
      <CRUDDialog baseCrudKey="paymentAuditRecord" :canCancel="false"
      @upsertItem="upsertAuditTransaction">
      <template v-slot:[`editedItem`]="{}">
        <AuditRecord baseCrudKey="paymentAuditRecord" />
      </template>
    </CRUDDialog>
    <CRUDDialog baseCrudKey="paymentAuditRecordForVoid" :canCancel="false"
      @upsertItem="upsertAuditTransactionForVoids">
      <template v-slot:[`editedItem`]="{}">
        <AuditRecord baseCrudKey="paymentAuditRecordForVoid" />
      </template>
    </CRUDDialog>
    <CRUDDialog dialogDynamicWidth="70vw" :canSave="false"
      baseCrudKey="ComhDecalmmonDecalDialogCrudKey" >
      <template v-slot:[`editedItem`]="{}">
        <CommonDecalDialog />
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="upsertCommonDecalDialogCrudKey">Save</v-btn>
      </template>
    </CRUDDialog>
    </div>
</template>

<script>
import {
  mapMutations,
  mapGetters, mapState,
  mapActions,
} from 'vuex';
import {
  mdiCircleSlice8,
} from '@mdi/js';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import paymentDialog from '../../payments/paymenteditDialog/paymentDialog.vue';
// import { amountToNumber } from '../../../../util/shared/vue-global';
import { getBusinessDateForPaymentEntry, toFiscalYear, toShortDate } from '../../../../util/shared/tmc-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import PaymentCommonFunc from '../../common-utils/PaymentCommonFunc.mixin';
import { getPayNowPenaltyDate } from '../../common-utils/CommonTaxFunctionalities';
// import { POST_LOAD_COMP_TIMER } from '../../common-utils/constants';
import CommonPopUp from '../../common-utils/CommonPopUp.vue';
import UploadFile from '../../../common/UploadFile.vue';
import { isEmptyObject } from '../../../../util/shared/vue-global';
import AuditRecord from '../../payments/audit/auditRecord.vue';
import CommonDecalDialog from '../../payments/paymenteditDialog/commonDecalDialog.vue';
import '../../../../assets/style.css';
// import { isEmptyObject } from '../../../../util/shared/vue-global';

export default {
  name: 'CommonPaymentDialog',
  mixins: [PaymentCommonFunc],
  props: {
    baseCrudKey: {
      type: String,
      default: 'paymentTransactionList',
    },
    fromCompBaseCrudKey: {
      type: String,
      default: 'baseCrudShortCutKey',
    },
    isThereMultipleItems: {
      type: Boolean,
      default: false,
    },
    isItFromJuneResale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Snapshot {key,item} captured when the Payrix dialog opens, so the success
      // watcher can restore the payment if the live CRUD item is cleared before it
      // fires (Suspect A). Cleared after a successful save.
      ccPaymentItemSnapshot: null,
      fiscalYear: toFiscalYear(new Date()),
      icons: {
        mdiCircleSlice8,
      },
      popUpMtgCodeRemoveOrNot: false,
      mtgCodeItems: [],
      showOrHideLatestPostDate: false,
      activeTransItem: undefined,
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      enableUploadFile: false,
    };
  },
  components: {
    CRUDDialog,
    paymentDialog,
    CommonPopUp,
    UploadFile,
    AuditRecord,
    CommonDecalDialog,
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'criteria', 'isValidFormProp', 'index', 'isVisible']),
    ...mapGetters(['todaysDate']),
    ...mapGetters('tax/taxPayment', ['getPaymentDialogBusinessDate']),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      upsertItem: (state) => state.tax.taxPayment.upsertItem || {},
      storedSelectedItems: (state) => state.tax.taxPayment.selectedItems,
      fortePaymentSuscessFlag: (state) => state.ForteService.fortePaymentSuscessFlag,
      forteIndex: (state) => state.ForteService.forteIndex,
      payrixSuccessFlag: (state) => state.common.payrixPayment.paymentSuccessFlag,
      isPayrixDialogOpen: (state) => state.common.payrixPayment.isDialogOpen,
      activeItemIndex: (state) => state.common.payrixPayment.activeItemIndex,
      isVisiblePIcklistDialog: (state) => state.base.crud.isVisible.pickListMakePaymentDialog,
    }),
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      // return !this.editedItem._id;
      return this.index(this.baseCrudKey) === -1;
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    selectedComponentCriteria() {
      return this.criteria(this.fromCompBaseCrudKey) || {};
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setIndex', 'setHighlightedId']),
    ...mapActions('tax/taxInquires', [
      'removeMtgCodesFromTaxInquiry',
    ]),
    ...mapActions('SystemConfig', [
      'getGlobalSettingStore',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setSelectedItems',
    ]),
    async handlePaymentDialog() {
      // Always a new payment. The crud key is shared with Tax Payments, and only some callers
      // reset it, so a leftover index / record made Images treat this payment as saved.
      this.setIndex([this.baseCrudKey, -1]);
      this.activeTransItem = undefined;
      const globalSettingVariables = await this.getGlobalSettingStore({});
      const todaysDate = toShortDate();
      let bussDate = todaysDate;
      const bussDateChangeIndividually = this.paymentSettingItem.changeBussDateIndividually;
      if (!bussDateChangeIndividually) {
        bussDate = (globalSettingVariables.configuration || {}).businessDate || todaysDate;
      } else {
        const localBussDate = getBusinessDateForPaymentEntry();
        bussDate = localBussDate || todaysDate;
      }
      this.paymentReRenderFlag = true;
      // const fyItem = { fiscalYear: this.fiscalYear };
      // this.startTheCounter(fyItem);
      // Postmark OK: the lines are priced on the previous penalty period's end, so the header
      // shows that date too (as a new payment on the Payments screen does). June resale carries
      // its own penalty amounts, so it is left alone.
      const prnaltyChangeDate = getPayNowPenaltyDate({
        criteriaPenaltyDate: this.selectedComponentCriteria.penaltyDateValue,
        todaysDate: this.todaysDate,
        penaltyChangeDay: this.taxSettingItem.penaltyDate,
        isPostmark: this.halfOrPostmark.dialogPostmark && !this.isItFromJuneResale,
      });
      const taxItems = [];
      let ownerName = '';
      if (this.isThereMultipleItems) {
        const items = this.items(this.fromCompBaseCrudKey);
        (items || []).forEach((el) => {
          // if it is not from June resale, then we need to set the penaltyAmt to null
          let penaltyAmt = null;
          if (this.isItFromJuneResale) {
            penaltyAmt = el.penaltyAmt;
          }
          // this is for june resale, even if they have 0, load those records
          if (this.isItFromJuneResale || el.totalDue > 0) {
            const taxItem = {
              _id: el._id,
              taxYear: el.taxYear,
              taxId: el.taxId,
              itsNewRecord: true,
              penaltyAmt,
              reciept: null,
              certNumber: el.certificate || null,
              ownerName: `${el.name1 || ''} ${el.name2 || ''}`,
              schoolDistrict: el.schoolDistrict,
              originalTaxId: el.taxId,
              taxAmt: null,
              taxType: 'TAXPAYMENT',
              total: null,
              thereIsAPrevUnptRec: false,
              isFromOtherSources: true,
            };
            taxItems.push(taxItem);
          }
        });
        ownerName = (items || [])[0].name1 || '';
      } else {
        const item = this.item(this.fromCompBaseCrudKey);
        const taxItem = {
          _id: item._id,
          taxYear: item.taxYear,
          taxId: item.taxId,
          originalTaxId: item.taxId,
          itsNewRecord: true,
          penaltyAmt: null,
          reciept: null,
          certNumber: item.certificate || null,
          schoolDistrict: item.schoolDistrict,
          ownerName: `${item.name1 || ''} ${item.name2 || ''}`,
          taxAmt: null,
          taxType: 'TAXPAYMENT',
          total: null,
          thereIsAPrevUnptRec: false,
          isFromOtherSources: true,
        };
        taxItems.push(taxItem);
        ownerName = item.name1 || '';
      }
      let paidBy = '';
      // if the pre-fill-paid-by is true then add paidBy
      if (this.paymentSettingItem.preFillPaymentWithOwnerName) paidBy = ownerName;
      const paymentDetails = {
        paidBy,
        paymentType: '',
        amount: '0',
      };
      if (this.isItFromJuneResale) {
        paymentDetails.paymentType = 'CASH';
        paymentDetails.amount = this.selectedComponentCriteria.amount;
        paymentDetails.paidBy = this.selectedComponentCriteria.paidBy;
      }
      const payDate = bussDate || this.getPaymentDialogBusinessDate;
      const formatedDateForFiscalYear = payDate
        ? new Date(payDate) : new Date(this.todaysDate);
      const fiscalVal = toFiscalYear(formatedDateForFiscalYear);
      const editItem = {
        taxDetails: taxItems,
        paymentDetails: [paymentDetails],
        fiscalYear: fiscalVal,
        payDate,
        workstation: Number(getWorkstationNumber()) || null,
        penaltyDate: prnaltyChangeDate,
        paymentNumber: 0,
      };
      this.setItem([this.baseCrudKey, editItem]);
      this.setIsVisible([this.baseCrudKey, true]);

      // If a user tries to create a payment on a date that is less than or equal to the
      // 'Latest Post Date', then we need warning message
      setTimeout(() => {
        if (this.paymentSettingItem.latestPostDate) {
          const formattedPayDate = new Date(payDate);
          const formattedLatestPostDate = new Date(this.paymentSettingItem.latestPostDate);
          formattedLatestPostDate.setDate(formattedLatestPostDate.getDate() + 1);
          if (formattedPayDate < formattedLatestPostDate) {
            this.showOrHideLatestPostDate = true;
          }
        }
      }, 100);
    },
    async onUpsertCall(isItFromSaveNPrint) {
      // Ignore a re-click / double-click while the first save is still running - see
      // isDuplicateSaveClick (two no-paymentNumber calls create two payment records).
      if (this.isDuplicateSaveClick()) return;
      const item = this.item(this.baseCrudKey);
      this.preUpsertTransaction(item, true, isItFromSaveNPrint);
    },
    async openPopUpForMtgCodeRemoveOrNot(whatIsIt) {
      if (whatIsIt === 'Remove') {
        const item = this.mtgCodeItems;
        await this.removeMtgCodesFromTaxInquiry({ item });
        this.popUpMtgCodeRemoveOrNot = false;
        this.mtgCodeItems = [];
      } else {
        this.popUpMtgCodeRemoveOrNot = false;
        this.mtgCodeItems = [];
      }
    },
    getMtgCodesMsg() {
      const mtgArr = (this.mtgCodeItems || []).map((dt) => dt.mtgCode);
      const mtgMsg = `Would you like to remove mortgage code ${(mtgArr || []).toString()} from this record?`;
      return mtgMsg;
    },
    callTheBroadBand(response) {
      this.$emit('upsertFuncCall', response);
      // link: https://developer.mozilla.org/en-US/docs/Web/API/Broadcast_Channel_API
      // used to send messages, and i am using to reload the payments page
      // as it uses event-listenner
      const bc = new BroadcastChannel('payment_reload_channel');
      bc.postMessage('reload');
    },
    async preUpsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint,
      shouldCloseDialog = true, skipFormValidation = false) {
      // skipFormValidation is for post-charge credit-card saves only. Two reasons the
      // isValidFormProp guard must not gate them:
      // 1. The money has already moved at the gateway — blocking here loses the payment
      //    record silently (no else branch, no flash), and the clerk sees no error.
      // 2. A payment made from the pick list lives under the 'pickListMakePaymentDialog'
      //    crud key, whose form is rendered by PickListTable's CRUDDialog. This component's
      //    key ('paymentTransactionList') never gets a validity flag in that flow, and
      //    base/crud ensureInit seeds a missing key with {} — so `.value` is undefined and
      //    the guard is always false. See PickListTable.preUpsertTransaction, which has the
      //    same guard commented out for the same reason.
      if (skipFormValidation || this.isValidFormProp(this.baseCrudKey).value) {
        this.enableUploadFile = true;
        const response = await this.upsertTransaction(
          item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog,
        );
        this.enableUploadFile = false;

        // if the resetTheDialog is false, then we can stop the execution here
        // this will prevent the data loss in payment dialog
        if (!response.resetTheDialog) return undefined;

        // the dialog stays open (Images on a new payment) - keep editing the saved payment
        if (!shouldCloseDialog && !isEmptyObject(response)) {
          this.updateActiveTransItem(response);
        }
        this.setDefaultSelectedItems();
        this.callTheBroadBand(response);
        return response;
      }
      return undefined;
    },
    async openConfirmPopUp(cancleOrContinue) {
      if (cancleOrContinue === 'Cancel') {
        this.showOrHideLatestPostDate = false;
        this.setIsVisible([this.baseCrudKey, false]);
      } else {
        this.showOrHideLatestPostDate = false;
      }
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        await this.saveNewPaymentThenAttach(() => this.saveForImages(), leftClick);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        await this.saveNewPaymentThenAttach(() => this.saveForImages(), rightClick);
      } else {
        rightClick();
      }
    },
    // The save behind Images: the same form check as Save, but the dialog stays open.
    async saveForImages() {
      if (!this.isValidFormProp(this.baseCrudKey).value) {
        this.flashWarn('Payment could not be saved - fix the highlighted fields, then attach the images.');
        return undefined;
      }
      return this.preUpsertTransaction(this.item(this.baseCrudKey), true, false, false);
    },

    activateTransaction(val) {
      this.activeTransItem = val;
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: (this.activeTransItem || {})._id || 'n/a',
      });
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.baseCrudKey, res]);
      this.setIndex([this.baseCrudKey, 0]);
    },
    // Point the open dialog (and its UploadFile) at the payment that was just saved. Only a
    // response with an _id is a saved payment - an early {} return must not mark it saved.
    updateActiveTransItem(res) {
      if (res && res._id) this.settingFields(res);
    },
    // Removed redundant upsrtTransaction method as it was causing issues
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    async applySuccessfulPayment() {
      let isPaymentFromPickList = this.isVisiblePIcklistDialog;
      const paymentKey = isPaymentFromPickList ? 'pickListMakePaymentDialog' : this.baseCrudKey;
      let savedItem = this.item(paymentKey);
      const hasDetails = (it) => !!(it && Array.isArray(it.paymentDetails) && it.paymentDetails.length);
      // Suspect A: the watcher can fire after the live CRUD item has been cleared.
      // Restore it from the snapshot taken when the Payrix dialog opened so the whole
      // save chain has the data and the record is still created instead of lost.
      const restoredFromSnapshot = !hasDetails(savedItem)
        && this.ccPaymentItemSnapshot && hasDetails(this.ccPaymentItemSnapshot.item);
      if (restoredFromSnapshot) {
        savedItem = JSON.parse(JSON.stringify(this.ccPaymentItemSnapshot.item));
        // Route by the key the item was snapshotted under (not the now-possibly-changed
        // dialog state), so the restore, the save path, and the post-save setItem agree.
        isPaymentFromPickList = this.ccPaymentItemSnapshot.key === 'pickListMakePaymentDialog';
        this.setItem([this.ccPaymentItemSnapshot.key, savedItem]);
      }
      if (!hasDetails(savedItem)) {
        // No data anywhere — never fail silently: warn the clerk and reset the flag.
        console.warn('applySuccessfulPayment: no payment item available (live + snapshot both empty)');
        this.$store.dispatch('flashError', 'The card was charged but the payment could not be saved automatically. Please contact support before re-running.');
        this.ccPaymentItemSnapshot = null;
        this.$store.dispatch('common/payrixPayment/setPaymentSuccessFlag', { flag: false, transactionId: '' });
        return;
      }
      if (!savedItem.payDate) {
        console.warn('applySuccessfulPayment: payDate is undefined or null, setting default', savedItem);
        savedItem.payDate = this.getPaymentDialogBusinessDate;
      }
      let payDateStr = String(savedItem.payDate);
      if (payDateStr === 'undefined' || payDateStr === 'null') {
        console.warn('applySuccessfulPayment: Invalid payDate after default, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        savedItem.payDate = payDateStr;
        this.setItem([this.baseCrudKey, savedItem]);
      }
      if (savedItem.payDate instanceof Date) {
        payDateStr = toShortDate(savedItem.payDate);
      }
      const [month, day, year] = payDateStr.split('-');
      if (!month || !day || !year || month === 'undefined') {
        console.warn('applySuccessfulPayment: Invalid payDate format, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        const [newMonth, newDay, newYear] = payDateStr.split('-');
        savedItem.payDate = `${newMonth.padStart(2, '0')}-${newDay.padStart(2, '0')}-${newYear}`;
      } else {
        const paddedPayDate = `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;
        savedItem.payDate = paddedPayDate;
      }
      const updatedPaymentDetails = (savedItem.paymentDetails || []).map((pd, index) => ({
        ...pd,
        ccProcessed: pd.paymentType === 'CREDIT' && this.activeItemIndex === index ? true : pd.ccProcessed,
      }));
      const updatedItem = {
        ...savedItem,
        paymentDetails: updatedPaymentDetails,
      };
      const crudKey = isPaymentFromPickList ? 'pickListMakePaymentDialog' : this.baseCrudKey;
      this.setItem([crudKey, updatedItem]);
      // Set lastSavedPaymentItem BEFORE the upsert so it's available when needed
      try {
        await this.$store.dispatch('common/payrixPayment/setLastSavedPaymentItem', updatedItem);
      } catch (validationError) {
        console.error('Failed to prepare CC payment data:', validationError);
        const errorMsg = 'Credit card payment was processed but payment data is incomplete. '
          + 'Please check the console for details and contact support.';
        this.$store.dispatch('flashError', errorMsg);
        // Reset the success flag to prevent retry loops
        this.$store.dispatch('common/payrixPayment/setPaymentSuccessFlag', { flag: false, transactionId: '' });
        return;
      }
      if (isPaymentFromPickList) {
        // skipFormValidation: the card is already charged, and the pick list's validity flag
        // lives under a different crud key than this component's baseCrudKey.
        await this.preUpsertTransaction(updatedItem, true, false, true, true);
      } else {
        await this.upsertTransaction(updatedItem);
      }
      // Snapshot consumed by a successful save — clear so it can't leak forward.
      this.ccPaymentItemSnapshot = null;
    },
    applySuccessfulFortePayment() {
      let savedItem = this.item(this.baseCrudKey);
      let isPaymentFromPickList = false;
      if (this.isVisiblePIcklistDialog) {
        isPaymentFromPickList = true;
        savedItem = this.item('pickListMakePaymentDialog');
      }
      if (!savedItem) {
        console.warn('applySuccessfulPayment: savedItem is empty');
        return;
      }
      if (!savedItem.payDate) {
        console.warn('applySuccessfulPayment: payDate is undefined or null, setting default', savedItem);
        savedItem.payDate = this.getPaymentDialogBusinessDate;
      }
      let payDateStr = String(savedItem.payDate);
      if (payDateStr === 'undefined' || payDateStr === 'null') {
        console.warn('applySuccessfulPayment: Invalid payDate after default, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        savedItem.payDate = payDateStr;
        this.setItem([this.baseCrudKey, savedItem]);
      }
      if (savedItem.payDate instanceof Date) {
        payDateStr = toShortDate(savedItem.payDate);
      }
      const [month, day, year] = payDateStr.split('-');
      if (!month || !day || !year || month === 'undefined') {
        console.warn('applySuccessfulPayment: Invalid payDate format, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        const [newMonth, newDay, newYear] = payDateStr.split('-');
        savedItem.payDate = `${newMonth.padStart(2, '0')}-${newDay.padStart(2, '0')}-${newYear}`;
      } else {
        const paddedPayDate = `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;
        savedItem.payDate = paddedPayDate;
      }
      const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
        const item = { ...paymentDetail };
        if (item.paymentType === 'CREDIT' && index === this.forteIndex) {
          item.ccProcessed = true;
        }
        return item;
      });
      const updatedItem = {
        ...savedItem,
        paymentDetails: updatedPaymentDetails,
      };
      // Persist the processed item to the store BEFORE saving (mirrors the Payrix watcher
      // applySuccessfulPayment) so the duplicate-payment guard in postUpsertTransaction can
      // carry the assigned paymentNumber back onto the store-bound object. Without this, a
      // re-fire of this Forte success watcher reads the still-null store item and saves a
      // fresh clone -> duplicate payment.
      const crudKey = isPaymentFromPickList ? 'pickListMakePaymentDialog' : this.baseCrudKey;
      this.setItem([crudKey, updatedItem]);
      if (isPaymentFromPickList) {
        this.preUpsertTransaction(updatedItem, true, false);
      } else {
        this.preUpsertTransaction(updatedItem, true, false);
      }
    },
    async applySuccessfulForte2Payment() {
      let savedItem = this.item(this.baseCrudKey);
      // let isPaymentFromPickList = false;
      if (this.isVisiblePIcklistDialog) {
        // isPaymentFromPickList = true;
        savedItem = this.item('pickListMakePaymentDialog');
      }
      // `!savedItem` alone misses the empty-{} case: the crud `item` getter defaults to {}, which
      // is truthy but has no paymentDetails, so the .map below would throw and drop a completed
      // charge's record. Match the Array.isArray idiom already used in the isPayrixDialogOpen watch.
      if (!savedItem || !Array.isArray(savedItem.paymentDetails)) {
        console.warn('applySuccessfulForte2Payment: no saved item / paymentDetails to update');
        return;
      }
      if (!savedItem.payDate) {
        console.warn('applySuccessfulForte2Payment: payDate is undefined or null, setting default', savedItem);
        savedItem.payDate = this.getPaymentDialogBusinessDate;
      }
      let payDateStr = String(savedItem.payDate);
      if (payDateStr === 'undefined' || payDateStr === 'null') {
        console.warn('applySuccessfulForte2Payment: Invalid payDate after default, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        savedItem.payDate = payDateStr;
        this.setItem([this.baseCrudKey, savedItem]);
      }
      if (savedItem.payDate instanceof Date) {
        payDateStr = toShortDate(savedItem.payDate);
      }
      const [month, day, year] = payDateStr.split('-');
      if (!month || !day || !year || month === 'undefined') {
        console.warn('applySuccessfulForte2Payment: Invalid payDate format, using fallback', payDateStr);
        payDateStr = this.getPaymentDialogBusinessDate;
        const [newMonth, newDay, newYear] = payDateStr.split('-');
        savedItem.payDate = `${newMonth.padStart(2, '0')}-${newDay.padStart(2, '0')}-${newYear}`;
      } else {
        const paddedPayDate = `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;
        savedItem.payDate = paddedPayDate;
      }
      const activeIndex = Number(this.forte2Payment.activeItemIndex);
      const updatedPaymentDetails = savedItem.paymentDetails.map((paymentDetail, index) => {
        const item = { ...paymentDetail };
        if (item.paymentType === this.forte2Payment.forte2PaymentType && index === activeIndex) {
          item.ccProcessed = true;
        }
        return item;
      });
      const updatedItem = {
        ...savedItem,
        paymentDetails: updatedPaymentDetails,
      };
      // skipFormValidation: same as the Payrix path — the charge has settled, and a pick-list
      // payment's validity flag is keyed to 'pickListMakePaymentDialog', not baseCrudKey.
      await this.preUpsertTransaction(updatedItem, true, false, true, true);
    },
  },
  watch: {
    isVisibleProp(newVal) {
      if (newVal) {
        this.$nextTick(() => { this.loadFiles(); });
      } else {
        this.activeTransItem = undefined;
        const attachmentConstants = {
          bucketName: 'taxInquiry',
          program: 'taxInquiry',
          parentObjectType: 'taxInquiryTransaction',
        };
        const item = this.item('TaxrollTransactionList');
        this.loadAttachedFiles({
          bucketName: attachmentConstants.bucketName,
          program: attachmentConstants.program,
          parentObjectType: attachmentConstants.parentObjectType,
          parentObjectId: (item || {})._id || 'n/a',
        });
      }
    },
    isPayrixDialogOpen(isOpen) {
      // Capture the payment item while the Payrix dialog is open (guaranteed present
      // here) so applySuccessfulPayment can restore it if the live CRUD item is
      // cleared before payrixSuccessFlag fires (Suspect A).
      if (isOpen) {
        const key = this.isVisiblePIcklistDialog ? 'pickListMakePaymentDialog' : this.baseCrudKey;
        const item = this.item(key);
        if (item && Array.isArray(item.paymentDetails) && item.paymentDetails.length) {
          this.ccPaymentItemSnapshot = { key, item: JSON.parse(JSON.stringify(item)) };
        }
      }
    },
    async payrixSuccessFlag(newVal) {
      if (newVal) {
        // The charge already succeeded — await so a rejection is actually caught
        // (a non-awaited promise rejection bypasses try/catch) and so the save's
        // async steps complete in order. Never let a failure vanish silently.
        try {
          await this.applySuccessfulPayment();
        } catch (e) {
          console.error('applySuccessfulPayment failed:', e);
          this.$store.dispatch('flashError', 'The card was charged but saving the payment failed unexpectedly. Please contact support before re-running.');
          // Clear the snapshot so a later flag flip can't silently re-save stale data.
          this.ccPaymentItemSnapshot = null;
          this.$store.dispatch('common/payrixPayment/setPaymentSuccessFlag', { flag: false, transactionId: '' });
        }
      }
    },
    fortePaymentSuscessFlag(newVal) {
      if (newVal && !this.isVisiblePIcklistDialog) {
        this.applySuccessfulFortePayment();
      }
    },
    async forte2SuccessFlag(newVal) {
      if (newVal) {
        await this.applySuccessfulForte2Payment();
      }
    },
  },
};
</script>
